import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

export const apiService = {
  async getArticles(category = null, limit = 50, skip = 0) {
    try {
      const params = { limit, skip };
      if (category && category !== 'all') {
        params.category = category;
      }
      const url = `${API}/articles`;
      console.log('[api] GET', url, params);
      const response = await axios.get(url, { params });
      console.log('[api] GET response', url, response.status);
      return response.data;
    } catch (error) {
      console.error('Error fetching articles:', error?.toJSON ? error.toJSON() : error);
      throw error;
    }
  },

  async getFeaturedArticles(limit = 3) {
    try {
      const url = `${API}/articles/featured`;
      console.log('[api] GET', url, { limit });
      const response = await axios.get(url, { params: { limit } });
      console.log('[api] GET response', url, response.status);
      return response.data;
    } catch (error) {
      console.error('Error fetching featured articles:', error?.toJSON ? error.toJSON() : error);
      throw error;
    }
  },

  async getVideos(category = null, limit = 12) {
    try {
      const params = { limit };
      if (category && category !== 'all') {
        params.category = category;
      }
      const url = `${API}/videos`;
      console.log('[api] GET', url, params);
      const response = await axios.get(url, { params });
      console.log('[api] GET response', url, response.status);
      return response.data;
    } catch (error) {
      console.error('Error fetching videos:', error?.toJSON ? error.toJSON() : error);
      throw error;
    }
  },

  async getDashboardData(category = null, articlesLimit = 6, articlesSkip = 0, featuredLimit = 5, videosLimit = 12) {
    try {
      const params = { 
        articles_limit: articlesLimit, 
        articles_skip: articlesSkip,
        featured_limit: featuredLimit,
        videos_limit: videosLimit
      };
      if (category && category !== 'all') {
        params.category = category;
      }
      const url = `${API}/dashboard`;
      console.log('[api] GET', url, params);
      const response = await axios.get(url, { params });
      console.log('[api] GET response', url, response.status);
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard data:', error?.toJSON ? error.toJSON() : error);
      throw error;
    }
  },

  async subscribeNewsletter(email) {
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, { email });
      return response.data;
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      throw error;
    }
  },

  async refreshContent() {
    try {
      const url = `${API}/scrape/refresh`;
      console.log('[api] POST', url);
      const response = await axios.post(url);
      console.log('[api] POST response', url, response.status);
      return response.data;
    } catch (error) {
      console.error('Error refreshing content:', error?.toJSON ? error.toJSON() : error);
      throw error;
    }
  },

  async getArticleById(articleId) {
    try {
      const url = `${API}/articles/${articleId}`;
      console.log('[api] GET', url);
      const response = await axios.get(url);
      console.log('[api] GET response', url, response.status);
      return response.data;
    } catch (error) {
      console.error('Error fetching article by ID:', error?.toJSON ? error.toJSON() : error);
      throw error;
    }
  }
};